
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/pipedrive",
      function () {
        return require("private-next-pages/whatsapp-integrations/pipedrive.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/pipedrive"])
      });
    }
  